import { render } from "./RecoveryPassword.vue?vue&type=template&id=d7518928&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"

import "./RecoveryPassword.vue?vue&type=style&index=0&id=d7518928&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7518928"]])

export default __exports__